import React from 'react';
import { NavLink } from 'react-router-dom';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';

const NavItem = ({ item, lang }) => {
  const { settings } = config;

  // Customized by Erkka 2025-08-12. There's a bug in restapi that prevents
  // translated portal_tabs titles from coming through to volto. Thus, temporarily,
  // translate here.
  const translations = {
    'My Folder': {
      fi: 'Oma kansio',
    },
  };
  const title = translations[item.title]?.[lang] || item.title;

  // The item.url in the root is ''
  // TODO: make more consistent it everywhere (eg. reducers to return '/' instead of '')
  if (isInternalURL(item.url) || item.url === '') {
    return (
      <NavLink
        to={item.url === '' ? '/' : item.url}
        key={item.url}
        className="item"
        activeClassName="active"
        exact={
          settings.isMultilingual
            ? item.url === `/${toBackendLang(lang)}`
            : item.url === ''
        }
      >
        {title}
      </NavLink>
    );
  } else {
    return (
      <a
        href={item.url}
        key={item.url}
        className="item"
        rel="noopener noreferrer"
        target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
      >
        {title}
      </a>
    );
  }
};

export default NavItem;
